import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateProductsGet = {
    path: "/affiliate/products",
    method: ERouteHttpVerb.GET
};
export { routeLocationAffiliateProductsGet };
